import { Component, Output, EventEmitter } from '@angular/core';
import { SocietiesService } from '@app/shared/services/societies.service';
declare var UIkit: any;

@Component({
  selector: 'app-add-society',
  templateUrl: './add-society.component.html',
  styleUrls: ['./add-society.component.scss']
})
export class AddSocietyComponent {

  public society : any = {
    Address: '',
    Name: '',
    Mobile: '',
    Code: '',
    ManagerLastName: '',
    ManagerFirstName: '',
    ManagerMobile: '',
    ManagerEMailAddress: '',
    AdminLastName: '',
    AdminFirstName: '',
    AdminMobile: '',
    AdminEMailAddress: ''
  };
  public validated : boolean = false;
  public loading : boolean = false;
  
  @Output() changed = new EventEmitter();

  constructor(
    private societyService: SocietiesService
  ) {}

  validator() {
    let result : boolean = true;

    this.validated = false;
    if (this.society.Name.length === 0 || this.society.Address.length === 0
      || this.society.Mobile.length === 0 || this.society.Code.length === 0) {
      result = false;
    }
    this.validated = result;
  }

  resetVariables() {
    this.society = {
      Address: '',
      Name: '',
      Mobile: '',
      Code: '',
      ManagerLastName: '',
      ManagerFirstName: '',
      ManagerMobile: '',
      ManagerEMailAddress: '',
      AdminLastName: '',
      AdminFirstName: '',
      AdminMobile: '',
      AdminEMailAddress: ''
    };
    this.validated = false;
  }

  submit() {
    this.loading = true;
    this.societyService.addSociety(this.society).then((res) => {
      this.loading = false;
      this.changed.emit(null);
      this.resetVariables();
      UIkit.modal('#add-society').hide();
    });
  }

}
